// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: QgajLOnNw3mf
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  renderPlasmicSlot
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { useScreenVariants as useScreenVariantseuyRl26Gw8Ft } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: EuyRl26Gw8Ft/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicConfirmEmail.module.css"; // plasmic-import: QgajLOnNw3mf/css

createPlasmicElementProxy;

export const PlasmicConfirmEmail__VariantProps = new Array();

export const PlasmicConfirmEmail__ArgProps = new Array("emailText");

const $$ = {};

function PlasmicConfirmEmail__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantseuyRl26Gw8Ft()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <div
            data-plasmic-name={"dashboardLoginDarkTheme"}
            data-plasmic-override={overrides.dashboardLoginDarkTheme}
            className={classNames(projectcss.all, sty.dashboardLoginDarkTheme)}
          >
            <div className={classNames(projectcss.all, sty.freeBox__iiKg)}>
              <Stack__
                as={"div"}
                data-plasmic-name={"frame1"}
                data-plasmic-override={overrides.frame1}
                hasGap={true}
                className={classNames(projectcss.all, sty.frame1)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__xSxJ
                  )}
                >
                  {"Verify your email"}
                </div>
                <div
                  className={classNames(projectcss.all, sty.freeBox___48CWo)}
                >
                  {renderPlasmicSlot({
                    defaultContents:
                      "Check sean1107obrien@gmail.com to verify your email account and get started",
                    value: args.emailText,
                    className: classNames(sty.slotTargetEmailText)
                  })}
                </div>
                <button
                  data-plasmic-name={"resendEmailButton"}
                  data-plasmic-override={overrides.resendEmailButton}
                  className={classNames(
                    projectcss.all,
                    projectcss.button,
                    sty.resendEmailButton
                  )}
                  ref={ref => {
                    $refs["resendEmailButton"] = ref;
                  }}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__lt6OK
                    )}
                  >
                    {"Resend Email"}
                  </div>
                </button>
              </Stack__>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: ["root", "dashboardLoginDarkTheme", "frame1", "resendEmailButton"],
  dashboardLoginDarkTheme: [
    "dashboardLoginDarkTheme",
    "frame1",
    "resendEmailButton"
  ],

  frame1: ["frame1", "resendEmailButton"],
  resendEmailButton: ["resendEmailButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicConfirmEmail__ArgProps,
          internalVariantPropNames: PlasmicConfirmEmail__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicConfirmEmail__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicConfirmEmail";
  } else {
    func.displayName = `PlasmicConfirmEmail.${nodeName}`;
  }
  return func;
}

export const PlasmicConfirmEmail = Object.assign(
  // Top-level PlasmicConfirmEmail renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    dashboardLoginDarkTheme: makeNodeComponent("dashboardLoginDarkTheme"),
    frame1: makeNodeComponent("frame1"),
    resendEmailButton: makeNodeComponent("resendEmailButton"),
    // Metadata about props expected for PlasmicConfirmEmail
    internalVariantProps: PlasmicConfirmEmail__VariantProps,
    internalArgProps: PlasmicConfirmEmail__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicConfirmEmail;
/* prettier-ignore-end */
